// src/pages/LoginPage.js - Triton Design Integration mit verbesserter Authentifizierung

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import TritonLogin from '../components/TritonLogin';
import { consumeLoginRedirect } from '../utils/loginRedirect';

function LoginPage() {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleUserSet = async (userData) => {
    try {
      // Trigger auth context update
      const success = await login(userData);
      
      if (!success) {
        console.error('❌ Login fehlgeschlagen');
      }
    } catch (error) {
      console.error('Login handler error:', error);
    }
  };

  // Fallback: Wenn Auth-Status auf true wechselt, navigiere imperativ
  useEffect(() => {
    if (isAuthenticated) {
      navigate(consumeLoginRedirect(), { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return <TritonLogin setUser={handleUserSet} />;
}

export default LoginPage;
